// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"

import "trix"
import "@rails/actiontext"

import "@hotwired/turbo-rails"
import "./controllers"


import smoothscroll from 'smoothscroll-polyfill';
// or if linting/typescript complains
//import * as smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();

document.addEventListener('ready turbo:load', () => {
  const toolTipElements = [...document.querySelectorAll('[data-toggle="tooltip"]')]
  toolTipElements.forEach((toolTipElement) => {
    new bootstrap.Tooltip(toolTipElement)
  })
});
